import type { Order } from "./types";

export const initialOrders: Order[] = [
  { id: "#NSJ2205", customer: "Priya Sharma", total: 5299, status: "Processing" },
  { id: "#NSJ2204", customer: "Sneha Verma", total: 8499, status: "Shipped" },
  { id: "#NSJ2203", customer: "Ritika Gupta", total: 2999, status: "Delivered" },
  { id: "#NSJ2202", customer: "Ananya Rao", total: 3299, status: "Delivered" },
  { id: "#NSJ2201", customer: "Isha Singh", total: 6599, status: "Processing" },
  { id: "#NSJ2200", customer: "Radhika Jain", total: 1799, status: "Cancelled" },
];
